import React, { useState } from 'react';
import { Slider, InputNumber, Button, Space, Typography } from 'antd';

const { Title } = Typography;

const ScaleEntry = ({ currentValue, onSubmit }) => {
  const [value, setValue] = useState(currentValue);

  const handleSliderChange = (value) => {
    setValue(value);
  };

  const handleInputChange = (value) => {
    setValue(value);
  };

  const handleSubmit = () => {
    onSubmit(value); // Trigger the passed onSubmit callback with the current value
  };

  return (
    <Space direction="vertical" size="large" align="center">
      <Title level={2}>{value}%</Title>
      <Slider
        min={0}
        max={100}
        step={1}
        value={value}
        onChange={handleSliderChange}
        marks={{
          0: '0%',
          25: '25%',
          50: '50%',
          75: '75%',
          100: '100%',
        }}
        style={{ width: 300 }}
      />
      <InputNumber
        min={0}
        max={100}
        style={{ width: 100 }}
        step={1}
        value={value}
        onChange={handleInputChange}
        formatter={(value) => `${value}%`}
        parser={(value) => value.replace('%', '')}
      />
      <Button type="primary" onClick={handleSubmit}>
        Submit
      </Button>
    </Space>
  );
};

export default ScaleEntry;